<div class="card">
  <div class="icon">
    <ng-content></ng-content>
  </div>
  <div>
    <h4 class="title">{{ title }}</h4>
    <p class="text">{{ text }}</p>
  </div>
</div>
